import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ImpactDashboard extends Vue {
  private isPreviewGoal: boolean = false;
  private isShowSubject: boolean = false;
  public backFlow() {
    this.$router.push('/impact-dashboard');
  }
  public createGoal() {
    this.isPreviewGoal = false;
  }
  public previewGoal() {
    this.isPreviewGoal = true;
  }
  public subjectDropdown() {
    this.isShowSubject = true;
  }
  public hideDropdown() {
    this.isShowSubject = false;
  }
  public previewCreateGoal() {
    this.$router.push({
      path: '/impact-growth',
      query: { name: 'parcc' },
    });
  }

}
